import IconSuccess from '@apollo/icons/default/IconSuccess.svg';
import { Heading, Link, Text } from '@apollo/orbit';
import React from 'react';

import { DocsRouter } from 'src/lib/routers';

import { Icon as NetflixLogo } from './logos/netflix.svg';
import { Icon as NewYorkTimesLogo } from './logos/nyt.svg';
import { Icon as PayPalLogo } from './logos/paypal.svg';
import { Icon as SquareLogo } from './logos/square.svg';
import { Icon as VolvoLogo } from './logos/volvo.svg';
import { Icon as WayfairLogo } from './logos/wayfair.svg';
import { Icon as ZillowLogo } from './logos/zillow.svg';

const DETAIL_LIST = [
  {
    title: 'Improved responsiveness',
    description: 'via real-time updates and distributed caching',
  },
  {
    title: 'CI/CD integration',
    description: 'to protect against breaking changes',
  },
  {
    title: 'API filtering',
    description: 'for apps and audiences with limited scope',
  },
  {
    title: 'Security and auth policies',
    description: 'enforced directly in the gateway',
  },
];

export const EnterpriseTrialDetailsPage = () => (
  <>
    <div className="rounded-md bg-primary p-8 md:p-10">
      <Heading className="mb-1" size="2xl">
        Scale your GraphQL API with Apollo
      </Heading>
      <Text variant="subtitle">
        Combine your microservices and data stores into one GraphQL API, and
        deploy Apollo’s blazing-fast gateway to your own cloud. With Apollo
        Enterprise, your entire platform benefits from:
      </Text>
      <ul className="my-8">
        {DETAIL_LIST.map(({ title, description }) => (
          <li key={title} className="mb-3 flex gap-2 last:mb-0">
            <IconSuccess className="my-1 flex-none text-icon-success" />
            <div>
              <strong>{title}</strong> {description}
            </div>
          </li>
        ))}
      </ul>
      <Text>
        And more! For a full list of Enterprise features,{' '}
        <Link
          isExternal
          to={DocsRouter.path('EntepriseFeatures')}
          data-analytics-category="Enterprise Trial Sign Up"
          data-data-analytics-label="Docs link clicked"
          className="whitespace-nowrap"
        >
          read our docs
        </Link>
        .
      </Text>
    </div>
    <div className="mt-11 text-white">
      <div className="mb-6 text-center">Enterprise teams trust Apollo</div>
      <div className="flex flex-col flex-wrap items-center justify-center gap-x-10 gap-y-6 md:flex-row">
        <PayPalLogo className="h-6 fill-current" />
        <SquareLogo className="h-6 fill-current" />
        <NetflixLogo className="h-6 fill-current" />
        <VolvoLogo className="h-4 fill-current" />
        <WayfairLogo className="h-6 fill-current" />
        <ZillowLogo className="h-6 fill-current" />
        <NewYorkTimesLogo className="h-6 fill-current" />
      </div>
    </div>
  </>
);
